import clsx from "clsx";
import { observer } from "mobx-react-lite";
import CloseIcon from "../../../../../Icons/CloseIcon";
import SearchIcon from "../../../../../Icons/SearchIcon";
import MainHeaderStore from "../../../../stores/MainHeaderStore";
import useMainHeaderSearch from "../helpers/useMainHeaderSearch";
import { MainHeaderSearchResult } from "./components/MainHeaderSearchResult";
import s from "./MainHeaderSearch.module.scss";

interface Props {
  mainHeaderStore: MainHeaderStore;
  mainPage?: boolean;
}

export const MainHeaderSearch: React.FC<Props> = observer(
  ({ mainHeaderStore, mainPage }) => {
    // const mainHeaderStore = useStore(MainHeaderStore, []);
    const { handleOnChange, handleFocus, wrapperRef, clear } =
      useMainHeaderSearch({
        mainHeaderStore,
      });
    return (
      <div className={clsx(s.wrapper, mainPage && s.main)} ref={wrapperRef}>
        <div className={s.field}>
          <div className={s.field_search}>
            <SearchIcon color={mainPage ? "#fff" : "#0D0C21"} />
          </div>
          <input
            type="text"
            placeholder="Search for collections"
            onChange={handleOnChange}
            onFocus={handleFocus}
            value={mainHeaderStore.searchString}
          />
          {mainHeaderStore.searchString !== "" && (
            <div className={s.clear} onClick={clear}>
              <CloseIcon color={mainPage ? "#fff" : "#4C4B5B"} />
            </div>
          )}
        </div>
        <div className={s.result}>
          <MainHeaderSearchResult mainHeaderStore={mainHeaderStore} />
        </div>
      </div>
    );
  }
);
